<p-toast></p-toast>

<div class="registration-page">
  <div class="registration-shell">
    <section class="hero-panel">
      <div class="hero-overlay"></div>

      <div class="hero-topline">
        <div class="hero-brand">
          <img src="assets/images/loadgate-new-logo.png" alt="LoadGate" class="hero-logo" />
          <div class="hero-brand-copy">
            <span class="brand-pill">{{ 'REGISTRATION.BRAND' | translate }}</span>
            <span class="brand-subtitle">{{ 'REGISTRATION.TITLE' | translate }}</span>
          </div>
        </div>
      </div>

      <div class="hero-copy">
        <h1>{{ 'REGISTRATION.HERO_TITLE' | translate }}</h1>
        <p>
          {{ 'REGISTRATION.HERO_DESC' | translate }}
        </p>
      </div>

      <div class="hero-highlights">
        <div class="highlight-chip">
          <i class="pi pi-verified"></i>
          <span>{{ 'REGISTRATION.HIGHLIGHT_VERIFIED' | translate }}</span>
        </div>
        <div class="highlight-chip">
          <i class="pi pi-map-marker"></i>
          <span>{{ 'REGISTRATION.HIGHLIGHT_MAP' | translate }}</span>
        </div>
        <div class="highlight-chip">
          <i class="pi pi-truck"></i>
          <span>{{ 'REGISTRATION.HIGHLIGHT_ROLES' | translate }}</span>
        </div>
      </div>
    </section>

    <section class="form-panel" [formGroup]="form">
      @if (registrationCompleted) {
      <div class="form-header">
        <div>
          <span class="section-pill">{{ 'REGISTRATION.CHECK_EMAIL' | translate }}</span>
          <h2>{{ 'REGISTRATION.FINISH_SETUP' | translate }}</h2>
        </div>
        <p>{{ registrationCompletionMessage }}</p>
      </div>

      <div class="form-card">
        <div class="card-heading">
          <div>
            <span class="mini-pill">{{ 'REGISTRATION.NEXT_STEP' | translate }}</span>
            <h3>{{ 'REGISTRATION.SETUP_EMAIL_DESC' | translate }}</h3>
          </div>
        </div>

        <p class="m-0 text-600">
          {{ 'REGISTRATION.SETUP_FOOTER' | translate }}
        </p>

        <div class="submit-bar mt-4">
          <div class="submit-copy">
            <h3>{{ 'REGISTRATION.READY_TITLE' | translate }}</h3>
            <p>{{ 'REGISTRATION.READY_DESC' | translate }}</p>
          </div>

          <p-button
            [label]="'REGISTRATION.GO_TO_LOGIN' | translate"
            styleClass="submit-button"
            type="button"
            (onClick)="goToLogin()">
          </p-button>
        </div>
      </div>
      } @else {
      <div class="form-header">
        <div>
          <span class="section-pill">{{ 'REGISTRATION.CREATE_ACCOUNT' | translate }}</span>
          <h2>{{ 'REGISTRATION.REGISTER_COMPANY' | translate }}</h2>
        </div>
        <p>{{ 'REGISTRATION.REGISTER_DESC' | translate }}</p>
      </div>

      <div class="form-card">
        <div class="card-heading">
          <div>
            <span class="mini-pill">{{ 'REGISTRATION.PRIMARY_CONTACT' | translate }}</span>
            <h3>{{ 'REGISTRATION.CONTACT_DESC' | translate }}</h3>
          </div>
        </div>

        <div class="formgrid grid">
          <div class="field col-12 md:col-6" [class.field-invalid]="isInvalid('fullName')">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
              <p-iftaLabel class="w-full">
                <input pInputText id="fullName" formControlName="fullName" placeholder=" " />
                <label for="fullName">{{ 'REGISTRATION.LBL_FULL_NAME' | translate }}</label>
              </p-iftaLabel>
            </p-inputGroup>
            @if(form.get('fullName')?.invalid && form.get('fullName')?.touched) {
            <small class="p-error">{{ 'REGISTRATION.ERROR_FULL_NAME' | translate }}</small>
            }
          </div>

          <div class="field col-12 md:col-6" [class.field-invalid]="isInvalid('mobileNumber')">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-phone"></i></p-inputGroupAddon>
              <p-iftaLabel class="w-full">
                <p-inputMask
                  id="mobileNumber"
                  formControlName="mobileNumber"
                  mask="+966-99-999-9999"
                  placeholder=" "
                  styleClass="w-full">
                </p-inputMask>
                <label for="mobileNumber">{{ 'REGISTRATION.LBL_MOBILE' | translate }}</label>
              </p-iftaLabel>
            </p-inputGroup>
            @if(form.get('mobileNumber')?.invalid && form.get('mobileNumber')?.touched) {
            <small class="p-error">{{ 'REGISTRATION.ERROR_MOBILE' | translate }}</small>
            }
          </div>

          <div class="field col-12 md:col-6" [class.field-invalid]="isInvalid('email')">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-envelope"></i></p-inputGroupAddon>
              <p-iftaLabel class="w-full">
                <input pInputText id="email" type="email" formControlName="email" placeholder=" " />
                <label for="email">{{ 'REGISTRATION.LBL_EMAIL' | translate }}</label>
              </p-iftaLabel>
            </p-inputGroup>
            @if(form.get('email')?.hasError('required') && form.get('email')?.touched) {
            <small class="p-error">{{ 'REGISTRATION.ERROR_EMAIL_REQUIRED' | translate }}</small>
            } @else if(form.get('email')?.hasError('email') && form.get('email')?.touched) {
            <small class="p-error">{{ 'REGISTRATION.ERROR_EMAIL_INVALID' | translate }}</small>
            }
          </div>

          <div class="field col-12 md:col-6">
            <div class="social-locked-note">
              <i class="pi pi-envelope"></i>
              <div>
                <strong>{{ 'REGISTRATION.SECURE_EMAIL_TITLE' | translate }}</strong>
                <p class="m-0 text-500">
                  @if (isSocialSignIn) {
                  {{ 'REGISTRATION.SOCIAL_NO_PASSWORD' | translate }}
                  } @else {
                  {{ 'REGISTRATION.SECURE_EMAIL_DESC' | translate }}
                  }
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="social-row">
          <span>{{ 'REGISTRATION.OR_CONTINUE' | translate }}</span>
          <div class="grid">
            <div class="col-12 sm:col-6 lg:col">
              <p-button label="Google" icon="pi pi-google" type="button" styleClass="social-button w-full" (onClick)="signInWithSocial('google')"></p-button>
            </div>
            <div class="col-12 sm:col-6 lg:col">
              <p-button label="Microsoft" icon="pi pi-microsoft" type="button" styleClass="social-button w-full" (onClick)="signInWithSocial('microsoft')"></p-button>
            </div>
            <div class="col-12 sm:col-6 lg:col">
              <p-button label="Apple" icon="pi pi-apple" type="button" styleClass="social-button w-full" (onClick)="signInWithSocial('apple')"></p-button>
            </div>
            <div class="col-12 sm:col-6 lg:col">
              <p-button label="Facebook" icon="pi pi-facebook" type="button" styleClass="social-button w-full" (onClick)="signInWithSocial('facebook')"></p-button>
            </div>
            <div class="col-12 sm:col-6 lg:col">
              <p-button label="Twitter" icon="pi pi-twitter" type="button" styleClass="social-button w-full" (onClick)="signInWithSocial('twitter')"></p-button>
            </div>
          </div>
          @if(isSocialSignIn && socialProvider) {
          <small class="text-500 block mt-2">{{ 'REGISTRATION.SIGNED_IN_WITH' | translate:{provider: providerLabel(socialProvider)} }} @if (form.get('email')?.disabled) { {{ 'REGISTRATION.SOCIAL_LOCKED' | translate }} } @else { {{ 'REGISTRATION.SOCIAL_ENTER_EMAIL' | translate }} }</small>
          }
        </div>
      </div>

      <div class="form-card">
        <div class="card-heading">
          <div>
            <span class="mini-pill">{{ 'REGISTRATION.COMPANY_INFO' | translate }}</span>
            <h3>{{ 'REGISTRATION.BUSINESS_PROFILE' | translate }}</h3>
          </div>
        </div>

        <div class="formgrid grid">
          <div class="field col-12" [class.field-invalid]="isInvalid('searchLocation')">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
              <p-iftaLabel class="w-full">
                <app-location-search
                  formControlName="searchLocation"
                  (placeSelected)="placeSelect($event)"
                  class="w-full">
                </app-location-search>
                <label for="address">{{ 'REGISTRATION.ADDRESS' | translate }}</label>
              </p-iftaLabel>
            </p-inputGroup>
            @if(form.get('searchLocation')?.invalid && form.get('searchLocation')?.touched) {
            <small class="p-error">{{ 'REGISTRATION.ADDRESS_REQUIRED' | translate }}</small>
            }
          </div>

          <div class="field col-12" [class.field-invalid]="isInvalid('companyName')">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
              <p-iftaLabel class="w-full">
                <input pInputText id="companyName" formControlName="companyName" placeholder=" " />
                <label for="companyName">{{ 'REGISTRATION.COMPANY_NAME' | translate }}</label>
              </p-iftaLabel>
            </p-inputGroup>
            @if(form.get('companyName')?.invalid && form.get('companyName')?.touched) {
            <small class="p-error">{{ 'REGISTRATION.COMPANY_NAME_REQUIRED' | translate }}</small>
            }
          </div>

          <div class="field col-12 md:col-6" [class.field-invalid]="isInvalid('crNumber')">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
              <p-iftaLabel class="w-full">
                <input pInputText id="crNumber" formControlName="crNumber" placeholder=" " />
                <label for="crNumber">{{ 'REGISTRATION.CR_NUMBER' | translate }}</label>
              </p-iftaLabel>
            </p-inputGroup>
            @if(form.get('crNumber')?.invalid && form.get('crNumber')?.touched) {
            <small class="p-error">{{ 'REGISTRATION.CR_NUMBER_REQUIRED' | translate }}</small>
            }
          </div>

          <div class="field col-12 md:col-6" [class.field-invalid]="isInvalid('vatNumber')">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-wallet"></i></p-inputGroupAddon>
              <p-iftaLabel class="w-full">
                <input pInputText id="vatNumber" formControlName="vatNumber" placeholder=" " />
                <label for="vatNumber">{{ 'REGISTRATION.VAT_NUMBER' | translate }}</label>
              </p-iftaLabel>
            </p-inputGroup>
            @if(form.get('vatNumber')?.invalid && form.get('vatNumber')?.touched) {
            <small class="p-error">{{ 'REGISTRATION.VAT_NUMBER_REQUIRED' | translate }}</small>
            }
          </div>

          <div class="field col-12 md:col-6">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-globe"></i></p-inputGroupAddon>
              <p-iftaLabel class="w-full">
                <input pInputText id="websiteURL" formControlName="websiteURL" placeholder=" " />
                <label for="websiteURL">{{ 'REGISTRATION.WEBSITE_URL' | translate }}</label>
              </p-iftaLabel>
            </p-inputGroup>
          </div>
        </div>

        <div class="map-section">
          <div class="map-header">
            <div>
              <span class="mini-pill">Location Preview</span>
              <h4>Registered address on map</h4>
            </div>
          </div>

          <div class="map-canvas">
            <app-google-map
              [lat]="mapLatitude"
              [lng]="mapLongitude"
              [height]="'260px'">
            </app-google-map>
          </div>
        </div>
      </div>

      <div class="form-card">
        <div class="card-heading">
          <div>
            <span class="mini-pill">Additional Services</span>
            <h3>Choose how your company operates</h3>
          </div>
        </div>

        <div class="grid">
          <div class="col-12 md:col-6">
            <div class="service-tile" [class.active]="form.get('isTransportationAgency')?.value">
              <div class="service-top">
                <div class="service-icon teal">
                  <i class="pi pi-truck"></i>
                </div>
                <div class="service-toggle">
                  <p-checkbox formControlName="isTransportationAgency" [binary]="true" inputId="isTA"></p-checkbox>
                  <label for="isTA">Transportation Company</label>
                </div>
              </div>

              <p>For companies operating their own trucks, fleets, and drivers.</p>

              @if(form.get('isTransportationAgency')?.value) {
              <div class="field mt-3">
                <p-inputGroup>
                  <p-inputGroupAddon><i class="pi pi-id-card"></i></p-inputGroupAddon>
                  <p-iftaLabel class="w-full">
                    <input pInputText id="motLicense" formControlName="motAgencyLicenseNumber" placeholder=" " />
                    <label for="motLicense">MOT License Number</label>
                  </p-iftaLabel>
                </p-inputGroup>
              </div>
              }
            </div>
          </div>

          <div class="col-12 md:col-6">
            <div class="service-tile amber" [class.active]="form.get('isFreightForwarder')?.value">
              <div class="service-top">
                <div class="service-icon amber">
                  <i class="pi pi-send"></i>
                </div>
                <div class="service-toggle">
                  <p-checkbox formControlName="isFreightForwarder" [binary]="true" inputId="isFF"></p-checkbox>
                  <label for="isFF">Freight Forwarder</label>
                </div>
              </div>

              <p>For companies coordinating shipments and forwarding cargo on behalf of customers.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="submit-bar">
        <div class="submit-copy">
          <h3>Ready to create your LoadGate account?</h3>
          <p>Your company, contact, and selected services will be set up together.</p>
        </div>

        <p-button
          label="Create Account"
          styleClass="submit-button"
          [loading]="registering"
          [disabled]="registering"
          (onClick)="register()">
        </p-button>
      </div>
      }
    </section>
  </div>
</div>
